/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

// @ts-ignore
import {GeneralAssetUrl} from "./../../themes/kent/utilities/constants";

// @ts-ignore
interface IProps {
  product?: any;
}

class FatsacColors extends React.Component<IProps> {

  public render(): JSX.Element {
    return(
      <div className="full-width centered-text">
        <div className="small-padding">
          <h4>{'AVAILABLE COLOR OPTIONS:'}</h4>
          <p className="subheading">{'**Gray and Black are standard colors. Other colors are available for an extra custom color fee.'}</p>
        </div>
        <div className="row centered-text">
          <div className="small-6 medium-4" style={{"padding":"5px"}}>
            <img className="full-width" style={{"backgroundColor":"#939597"}} src={GeneralAssetUrl+"rectangle.png"} />
            <div className="white-background" style={{"padding":"10px"}}>
              <p className="no-margin">{'Grey'}</p>
            </div>
          </div>
          <div className="small-6 medium-4" style={{"padding":"5px"}}>
            <img className="full-width" style={{"backgroundColor":"#000000"}} src={GeneralAssetUrl+"rectangle.png"} />
            <div className="white-background" style={{"padding":"10px"}}>
              <p className="no-margin">{'Black'}</p>
            </div>
          </div>
          <div className="small-6 medium-4" style={{"padding":"5px"}}>
            <img className="full-width" style={{"backgroundColor":"#ed1c24"}} src={GeneralAssetUrl+"rectangle.png"} />
            <div className="white-background" style={{"padding":"10px"}}>
              <p className="no-margin">{'Red'}</p>
            </div>
          </div>
          <div className="small-6 medium-4" style={{"padding":"5px"}}>
            <img className="full-width" style={{"backgroundColor":"#ffffff","border":"1px solid #ccc"}} src={GeneralAssetUrl+"rectangle.png"} />
            <div className="white-background" style={{"padding":"10px"}}>
              <p className="no-margin">{'White'}</p>
            </div>
          </div>
          <div className="small-6 medium-4" style={{"padding":"5px"}}>
            <img className="full-width" style={{"backgroundImage":"url("+GeneralAssetUrl+"fat-sac-color-camo.png)"}} src={GeneralAssetUrl+"rectangle.png"} />
            <div className="white-background" style={{"padding":"10px"}}>
              <p className="no-margin">{'Camo'}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default FatsacColors;
